import { z } from 'zod';

import { HISTORY_ACTORS } from '~/data/contract';

// Response schema for call-off version snapshot
export const zodCallOffVersionResponseSchema = z.object({
  action: z.string(),
  actor: z.enum(HISTORY_ACTORS),
  actorDisplay: z.string().nullish(),
  createdAt: z.iso.datetime({ offset: true }),
  notes: z.string().nullish(),
  previousStatus: z.string().nullish(),
  snapshot: z.record(z.string(), z.unknown()),
  status: z.string(),
  versionNumber: z.number().int(),
});
